var _path, _ellipse, _ellipse2, _path2, _polygon, _polygon2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _ellipse3, _path15, _path16, _path17, _path18, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManStandingNextToCode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a8ebc32a-e748-45d9-a61d-aeebf59cfff3",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1121.00005,
    height: 607.96199,
    viewBox: "0 0 1121.00005 607.96199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "source_code") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.14789,544.70467a92.17222,92.17222,0,0,1,32.02368-16.68392c32.65823-9.34364,66.44317-.29958,99.11525,8.44757,17.6391,4.72171,35.87786,9.60454,53.86608,11.6155,28.82416,3.22318,55.69008-1.27495,77.69306-13.0071,24.729-13.18383,42.54045-35.87523,47.64829-60.69279a70.48407,70.48407,0,0,0,1.28593-9.521q-3.65463,2.25441-7.33528,4.44022c-25.80935,15.32748-62.0852,29.65826-88.32908,10.88062-10.07437-7.20721-16.61059-19.25066-17.93452-33.0403-1.41783-14.77612,3.3362-29.50912,12.71615-39.40907a47.998,47.998,0,0,1,4.90566-4.50207c19.01181-15.17609,49.02343-15.99439,70.07515-.995,17.82789,12.70265,28.38926,35.65507,28.05028,58.93481a524.84185,524.84185,0,0,0,44.16619-30.97039l1.23084,1.57655a526.67316,526.67316,0,0,1-45.47066,31.79851,72.51073,72.51073,0,0,1-1.40193,11.21038c-5.22638,25.39384-23.41987,48.59132-48.66557,62.05449-22.36144,11.92331-49.62963,16.49823-78.857,13.23013-18.13781-2.02774-36.45006-6.93064-54.16067-11.6715-33.90127-9.07553-65.922-17.64846-98.04825-8.457-32.29131,9.23821-58.37466,37.579-64.90838,70.52114-6.53632,32.94354,6.75568,69.09513,33.07392,89.95877l-1.24263,1.56781c-26.89056-21.31772-40.47084-58.2563-33.7937-91.91573C176.16613,578.32112,188.82685,558.53,206.14789,544.70467Zm311.75247-82.2679c.75634-23.07932-9.54778-46.0053-27.18335-58.57032-22.18626-15.80879-54.652-13.45341-72.36735,5.24286-8.98829,9.48739-13.54065,23.634-12.17693,37.84291,1.2683,13.2143,7.503,24.73436,17.10678,31.60559,25.366,18.1489,60.84664,4.04919,86.14458-10.97506Q513.67887,465.05645,517.90036,462.43677Z",
    transform: "translate(-39.49997 -146.019)",
    fill: "#3f3d56"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.5,
    cy: 555.96199,
    rx: 278.5,
    ry: 13,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 268,
    cy: 594.96199,
    rx: 99,
    ry: 13,
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225,429.481v8s-9.02334,41.82913,5,40c23-3,6-37,6-37v-7Z",
    transform: "translate(-39.49997 -146.019)",
    fill: "#ffb8b8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "297.5 508.462 306.5 533.462 328.5 525.462 318.5 502.462 297.5 508.462",
    fill: "#ffb8b8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "242.5 533.462 236.5 555.462 259.5 562.462 260.5 539.462 242.5 533.462",
    fill: "#ffb8b8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M262,427.481l-2,11s-1,8,0,13,73,212,73,212l31-12-40-131-5-101Z",
    transform: "translate(-39.49997 -146.019)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M301,425.481l-4,148s-9,10-7,17-5,65-5,65l-6,29,26,8s5-26,9-29,27-93,27-99,17-139,17-139l-42-17Z",
    transform: "translate(-39.49997 -146.019)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M348,663.481s-11-12-17,0a242.98906,242.98906,0,0,1-15,25s-32,19,0,24c0,0,18,1,27-5s33-15,33-17-6-31.4-12-28.2S348,663.481,348,663.481Z",
    transform: "translate(-39.49997 -146.019)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M293,696.481s-9-13-17-4-18,35-18,35-18,27,10,26,30-11,30-11,4-26,4-27-2-11.27953-2-11.27953Z",
    transform: "translate(-39.49997 -146.019)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 247,
    cy: 45.96199,
    r: 28,
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M272,209.481l4,32,12,30,26-31v-15s-8-12-6-22Z",
    transform: "translate(-39.49997 -146.019)",
    fill: "#ffb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M286,248.481l-14-6-15,177,3,11s8,5,33,1,66-1,66-1l3-91-49-107Z",
    transform: "translate(-39.49997 -146.019)",
    fill: "#d0cde1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M261,423.481s19-165,18-168-18-11.12343-18-11.12343S232,263.481,233,270.481s19,155,19,155Z",
    transform: "translate(-39.49997 -146.019)",
    fill: "#575a89"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M337,411.481s-30-117-31-143-1-29-1-29,46-16,62,0l3,84s5,36,3,47a123.84612,123.84612,0,0,1-6,21s11,11,1,14-17-2-21,3S337,411.481,337,411.481Z",
    transform: "translate(-39.49997 -146.019)",
    fill: "#575a89"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M240,264.481s-12,0-11,14,0,79,0,79-9,55-6,59-1,17-1,17l18,4s2-14,6-15,10-30,10-30Z",
    transform: "translate(-39.49997 -146.019)",
    fill: "#575a89"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M375,387.481,370.408,395.83s-31.4962,25.082-15.95213,34.36653S385,405.481,385,405.481l5-9Z",
    transform: "translate(-39.49997 -146.019)",
    fill: "#ffb8b8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M353,237.481l14,2s16,11,17,17,33,61,33,61a32.54943,32.54943,0,0,1,3,13c0,7-11,60-17,61s-10,11-10,11l-21-13a51.04342,51.04342,0,0,1,1-9c1-5,5-15,5-15l6-21a7.5,7.5,0,0,1-3-6c0-4-17-25-17-25Z",
    transform: "translate(-39.49997 -146.019)",
    fill: "#575a89"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M282.88376,258.69047S257,251.481,259,246.481s4-6,4-6,3-8,6-8,5.568-2.45633,5.568-2.45633L286,248.481Z",
    transform: "translate(-39.49997 -146.019)",
    fill: "#d0cde1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M311.01492,219.981s9.98505-2.5,13.98505.5,7,3,8,5,14,4,10,7-57,16-57,16l25-18Z",
    transform: "translate(-39.49997 -146.019)",
    fill: "#d0cde1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M314.136,162.18809a34.51473,34.51473,0,0,0-19.6333-15.00922L288.5,151.981l2.33374-5.60114a31.773,31.773,0,0,0-5.93286-.34289L279.5,152.981l2.23536-6.70618a34.18477,34.18477,0,0,0-23.58228,14.0274c-6.874,9.91169-6.41394,23.68958.34692,33.67878,1.856-5.7035,2.48853-11.0492,4.34449-16.75275a16.88165,16.88165,0,0,0,4.39746.02142L269.5,171.981l.63074,5.04583c6.99866-.6098,17.3794-1.94842,24.01441-3.175L293.5,169.981l3.86,3.21667c2.03284-.468,3.23975-.89233,3.14-1.21667,4.93457,7.95514,9.824,13.03625,14.75843,20.99133C317.13157,181.75138,320.43833,172.42417,314.136,162.18809Z",
    transform: "translate(-39.49997 -146.019)",
    fill: "#2f2e41"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 273,
    cy: 41.96199,
    rx: 2,
    ry: 4,
    fill: "#ffb8b8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M143.71988,701.71232l-1.07324-.40235c-.23584-.08886-23.7085-9.082-34.7041-29.47363-10.99609-20.39258-5.61182-44.94531-5.55615-45.19043l.25342-1.11816,1.07275.40234c.23584.08887,23.708,9.082,34.7041,29.47363,10.99609,20.39258,5.61182,44.94532,5.55615,45.19043Zm-34.0166-30.8252c9.29639,17.24121,27.84522,26.0791,32.54492,28.09668.89356-5.03711,3.6958-25.40625-5.59228-42.63086-9.28711-17.22265-27.84326-26.07422-32.54492-28.09668C103.217,633.2963,100.41568,653.66349,109.70328,670.88712Z",
    transform: "translate(-39.49997 -146.019)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116.34573,664.68329c19.76056,11.88861,27.371,35.50267,27.371,35.50267s-24.42779,4.33881-44.18835-7.5498-27.371-35.50267-27.371-35.50267S96.58516,652.79468,116.34573,664.68329Z",
    transform: "translate(-39.49997 -146.019)",
    fill: "#000000"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M546.49992,442.819H1003.6838c86.60721,0,156.81623-49.36333,156.81623-135.97054v-.00032c0-86.60721-70.209-122.70511-156.81623-122.70511H860.13237c-173.21442,0-313.63245,85.46124-313.63245,258.67566Z",
    transform: "translate(-39.49997 -146.019)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M978.16306,421.84037H597.66892v-1c0-68.02539,26.50391-124.06933,76.64648-162.07373,46.30371-35.09473,110.168-53.645,184.68946-53.645h119.1582c38.00488,0,70.03027,8.35059,92.61621,24.14844,25.58106,17.894,38.55176,44.37451,38.55176,78.70508,0,34.50439-13.31055,63.6084-38.49317,84.166C1047.3779,411.2935,1014.46579,421.84037,978.16306,421.84037Zm-378.49219-2H978.16306c77.25977,0,129.168-44.95508,129.168-111.86474,0-64.09424-47.08008-100.854-129.168-100.854H859.00486C733.90134,207.12162,600.24118,263.03471,599.67087,419.84037Z",
    transform: "translate(-39.49997 -146.019)",
    fill: "#000000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 701,
    y: 125.96199,
    width: 54,
    height: 13,
    fill: "#000000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 923,
    y: 125.96199,
    width: 19,
    height: 13,
    fill: "#000000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 961,
    y: 125.96199,
    width: 19,
    height: 13,
    fill: "#000000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 774,
    y: 125.96199,
    width: 129,
    height: 13,
    fill: "#000000"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 633,
    y: 209.96199,
    width: 54,
    height: 13,
    fill: "#000000"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 855,
    y: 209.96199,
    width: 19,
    height: 13,
    fill: "#000000"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 893,
    y: 209.96199,
    width: 19,
    height: 13,
    fill: "#000000"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 706,
    y: 209.96199,
    width: 129,
    height: 13,
    fill: "#000000"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 856,
    y: 154.96199,
    width: 54,
    height: 13,
    fill: "#000000"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 929,
    y: 154.96199,
    width: 54,
    height: 13,
    fill: "#000000"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 1002,
    y: 154.96199,
    width: 19,
    height: 13,
    fill: "#000000"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 633,
    y: 154.96199,
    width: 19,
    height: 13,
    fill: "#000000"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 671,
    y: 154.96199,
    width: 19,
    height: 13,
    fill: "#000000"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 709,
    y: 154.96199,
    width: 129,
    height: 13,
    fill: "#000000"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 783.49997,
    y: 328.981,
    width: 54,
    height: 13,
    transform: "translate(1581.49997 524.94299) rotate(-180)",
    fill: "#000000"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 710.49997,
    y: 328.981,
    width: 54,
    height: 13,
    transform: "translate(1435.49997 524.94299) rotate(-180)",
    fill: "#000000"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 672.49997,
    y: 328.981,
    width: 19,
    height: 13,
    transform: "translate(1324.49997 524.94299) rotate(-180)",
    fill: "#000000"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1041.49997,
    y: 328.981,
    width: 19,
    height: 13,
    transform: "translate(2062.49997 524.94299) rotate(-180)",
    fill: "#000000"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1003.49997,
    y: 328.981,
    width: 19,
    height: 13,
    transform: "translate(1986.49997 524.94299) rotate(-180)",
    fill: "#000000"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 855.49997,
    y: 328.981,
    width: 129,
    height: 13,
    transform: "translate(1800.49997 524.94299) rotate(-180)",
    fill: "#000000"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 536.96199,
    width: 19,
    height: 15,
    fill: "#000000"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 309,
    y: 580.96199,
    width: 19,
    height: 15,
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManStandingNextToCode);
export default __webpack_public_path__ + "static/media/man-standing-next-to-code.ee98cb56bffa13f104de76c6166af7ee.svg";
export { ForwardRef as ReactComponent };